import authHeader from 'srcReact/helpers/auth-header'
import axios from 'axios'
import { doRequestAxios } from 'srcReact/helpers/apiHelper'

export const globalSearchService = {
  globalSearch
}

let cancel

function globalSearch(organization_id, search, latitude, longitude, filter, content_offset, content_quantity) {
  if (cancel !== undefined) {
    cancel()
  }

  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cancelToken: new axios.CancelToken((c) => (cancel = c)),
    params: { organization_id, search, latitude, longitude, filter, content_offset, content_quantity }
  }
  return doRequestAxios(`/v2/search/global`, requestOptions)
}
